export enum ModalMoveTo_Type {
    TASK        = 'task',
    MEETING     = 'meeting',
    PROJECT     = 'project',
    DOCUMENT    = 'document',
    MULTI       = 'multi',          // used in table ???
}

export enum MoveTo_CurrentStep {
    MAIN                = 'main',
    LOADING             = 'loading',
    SUBTASKS_ERROR      = 'subtasks-error',
    CHECKING_USERS      = 'checking-users',
    ADD_MISSING_USERS   = 'add-missing-users',
}